<template>
  <div >

    <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->

    <Section background="black"  class="image-bg"
             :style="{'background-image': `url(${require('../assets/images/content/background_math2.png')})`}"
    >

      <div style="width:100%">
        <nav-bar></nav-bar>
      </div>


      <div class="main-heading">
        <div class="heading-line">
          <div class="center display-3 pt-0">Data Science Consulting</div>
          <!--<div class="center title">Applying The Scientific Method To Business</div>-->
          <!--<div class="center headline pt-2 pb-5">We Guarantee Our Results</div>-->
          <div class="pt-6 pb-5">
            <v-btn  to="/services#services-consulting" color="primary" @click.native="track('HomeBtnGuarantee')">
              <span class="subtitle-1">We Guarantee Our Results</span>

            </v-btn>
          </div>

        </div>
      </div>





      <!-------------------------------------------services------------------------------------------------------------>
    </Section>

    <Section background="white" >

      <div class="bg-transparent-light">

        <v-container class="container-services">
          <v-row class="pa-5">
            <v-spacer></v-spacer>
            <v-col>
              <div class="section-heading">
                Our Services
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>


          <v-row class="pb-10">
            <v-col cols="12" sm="4" >

              <img src="../assets/images/icons/doubt.png" height="100px">

              <div class="section-sub-heading">Consulting</div>
              <div class="service-text">
                Looking to leverage your data but not sure where to start?
                Need a guide to filter the marketing BS from what's actually possible? We're here to help.
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <img src="../assets/images/icons/machine-learning.png" height="100px">
              <div class="section-sub-heading">Data Analytics</div>
              <div class="service-text">
                Need to create a statistical or machine learning model?  We've got you covered.
                We were building models when AI <span style="font-style: italic">wasn't  </span> a buzzword.
              </div>

            </v-col>
            <v-col cols="12" sm="4">
              <img src="../assets/images/icons/coding.png" height="100px">
              <div class="section-sub-heading">Development</div>
              <div class="service-text">
                Want to build an internal tool or a full fledged data driven customer facing app?  Our team
                has been writing software for 20+ years.
              </div>

            </v-col>
          </v-row>


          <v-row class="pt-5 pb-10">
            <v-spacer></v-spacer>
            <v-btn x-large to="/services" color="primary" @click.native="track('HomeLearnMore')">Learn More</v-btn>
            <v-spacer></v-spacer>
          </v-row>

        </v-container>
      </div>

    </Section>




    <!-------------------------------------------process--------------------------------------------------------------->
    <Section background="black">
      <!--<div class="process-section">-->
        <!--some text-->
      <!--</div>-->


      <div class="">

        <v-container class="container-services">
          <v-row align="center" >
            <v-col cols="12" sm="12" align="center">
              <div class="section-heading pb-0">Business is</div>
              <div class="section-heading pt-0">People executing Processes using Technology</div>
              <v-img
                      max-width="900"
                      position="center"
                      src="../assets/images/content/people_process_tech_8x.png"
              ></v-img>


              <div class="section-heading pb-0">The Best Companies</div>
              <div class="section-heading pt-0">Use Data to Optimize All Three</div>


              <!--<div class="process-section">-->

              <!--Data-->
              <!--</div>-->

            </v-col>

          </v-row>

          <v-row align="center">
            <v-col cols="12" sm="2" align="center">
              <v-img
                      max-width="150px"
                      position="center"
                      src="../assets/images/content/people@8x.png"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="10" align="left">
            <div class="colored-icon-text" style="color:#39B54A">
              Data might power decisions, but ultimately it’s people who make them.
            That’s why we start with a human centric decision framework designed to answer the
              <span style="font-style: italic">What</span>,
              <span style="font-style: italic">Why</span>, and
              <span style="font-style: italic">How</span>
            using data and the scientific method as guiding principles.
            </div>
            </v-col>
          </v-row>


          <v-row align="center">
            <v-col cols="12" sm="2" align="center">
              <v-img
                      max-width="150px"
                      position="center"
                      src="../assets/images/content/process@8x.png"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="10" align="left">
            <div class="colored-icon-text" style="color:#e52be1">
              Processes are the foundation of any business.  But over time they become stale and inefficient.
              By analyzing a process’s data and using appropriate statistical and mathematical models, we are able to measure how
              individual actions affect top level KPIs, thus showing you where bottlenecks and other performance issues
              within your processes reside.
            </div>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="12" sm="2" align="center">
              <v-img
                      max-width="150px"
                      position="center"
                      src="../assets/images/content/tech@8x.png"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="10" align="left">
            <div class="colored-icon-text" style="color:#3FA9F5">
              <!--Today’s AI is pretty dumb and could never hope to replace a person.-->
              <!--But by combining the latest data science techniques with classical software engineering,-->
              <!--we can create tools and systems that greatly increase your people's productivity.-->
              <!--In the end, technology is just a tool to help people be more efficient.-->

              Today’s AI is pretty dumb and could never hope to replace a person.
              But by combining the latest data science techniques with classical software engineering,
              we can create tools and systems that greatly increase people's productivity.
              In the end, technology is just a tool to help people be more efficient.
            </div>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="12" sm="2" align="center">
              <v-img
                      max-width="150px"
                      position="center"
                      src="../assets/images/content/data@8x.png"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="10" align="left">
              <div class="colored-icon-text" style="color:#7154FF">
                Data science isn't <span style="font-style: italic">really</span>  about data.
                It's about your business and pushing it to its performance limit.
                <!--But to do so we need to move beyond gut instinct.  -->
                But to do that, we need a framework that can integrate the thousands to millions of data points that need
                to be considered.  And that's all data science and analytics are.  They're tools that help connect the dots
                between what you do and how those actions affect your business.
              </div>
            </v-col>
          </v-row>

        </v-container>
      </div>

    </Section>










    <!-------------------------------customer comments----------------------------------------------------------------->
    <Section
            background="black"
            transparent
            style="padding-top: 50px"
    >

      <div  class="bg-transparent-light pt-0"   style="width:100%;" >

        <div class="section-heading pt-10 pb-0" >Our Customers</div>
        <vueper-slides autoplay speed="7000" :slide-ratio="slide_ratio" class="no-shadow" :arrows="show_arrows" >
          <vueper-slide
                  v-for="(slide, i) in slides"
                  :key="i"
                  :title="slide.title"
                  :content="slide.content"

          >
            <template v-slot:content>
              <div class="slide-container">
                <div class="slide-spacer"></div>

                <div class="slide-content">
                  <div>{{ slide.title }}</div>
                  <div class="" style="font-style: italic"> "{{ slide.content }}"</div>
                  <div  style="text-align: right"> {{ slide.author }}</div>
                </div>
                <div class="slide-spacer"></div>

              </div>

            </template>
          </vueper-slide>
        </vueper-slides>

      </div>


    </Section>



    <!-------------------------------------------------------contact us------------------------------------------------>
    <Section background="black" class="pt-10">

        <v-container fluid  style="max-width: 1000px">
          <v-row  justify="center" align="center">
            <v-col cols="12" md="6" align="center" >

              <div style="text-align: left">
                <p style="font-size: 1.5em">Can data science help your business?  </p>

                <p style="font-size: 1.5em">Drop us a note and let's find out.  </p>

                <p style="font-size: 1.5em">Thanks!</p>
              </div>





            </v-col>


            <v-col cols="12" md="6" align="center">
              <Contact></Contact>

            </v-col>
          </v-row>
        </v-container>


    </Section>





    <!--<div class="process-section">-->

      <!--some extra space for the moment-->

    <!--</div>-->



  </div>

</template>






<style scoped lang="scss">


  .image-bg{
    background-size: cover;
    background-position: center;
  }


  .main-heading{
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;

    }

  .heading-line{

    text-align: center;

  }


  .process-section{
    height: 700px;
    text-align: justify;

  }



  .bg-transparent-light{
    background: rgba(255, 255, 255, 0.05);
    width:100%;
  }


  .section-heading{
    font-size: 3em;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;

  }


  .section-sub-heading {
    font-size: 2em;
    font-weight: normal;
  }



  .container-services{
    max-width: 1200px;
    text-align: center;


    /*.service-heading{*/
      /*font-size: 2em;*/
      /*font-weight: normal;*/
    /*}*/

    .service-text{
      font-size: 1.0em;
      /*font-weight: lighter;*/
      line-height: 110%;
      text-align: justify;
      padding-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .colored-icon-text{
    font-size: 1.4em;
    /*font-size: 1.0em;*/
    /*text-align: left;*/
    text-align: justify;
    max-width: 800px;
  }










  .slide-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 200px;
  }

  .slide-content{
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 700px;

  }
  .slide-spacer{
    flex: 'flex-grow';
  }






</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue'
import Contact from '@/components/ContactForm.vue'
import navBar from '@/components/navBar.vue'

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'


export default {
  name: 'home',
  components: {navBar, Section, Contact, VueperSlides, VueperSlide},
   data(){return {
      slide_duration: 12,
      slides: [
         {
            title: 'MagnetiQ Brands Agency',
            content: 'These guys are awesome.  I only explained about 80% of what I wanted, but they came back with a 110% solution',
            author: 'DJ, Owner'
         },
         {
            title: 'Ping Bear Studios',
            content: 'The Espy team reviewed our marketing analytics and implemented a solution which automated our social media, cutting our campaign deployment time by 80%',
            author: 'Anthony, CEO'
         },

         // {
         //    title: 'DealerKnows Training',
         //    content: 'The guys at Espy Data Science built a custom app for us under a very tight deadline and did a great job.  ' +
         //       'I look forward to working with them on future projects.',
         //    author: 'Bill, Founder'
         // },

      ]
   }},

   methods:{
      track (eventLabel, category='SiteNavigation') {
         this.$gtag.event('ButtonClick', {
            'event_category': category,
            'event_label': eventLabel,
         })
      }
   },

   computed:{

     show_arrows(){
        if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) {
           return false;
        }
        else{
           return true;
        }
     },

     slide_ratio(){

        if (['xs'].includes(this.$vuetify.breakpoint.name)){
           return 0.7;
        }

        else if (['sm'].includes(this.$vuetify.breakpoint.name)){
           return 0.5;
        }
        else {
           return 0.3;
        }
     }
   },

   created(){
   }


}
</script>
